/* assets/wishlist.js */
(function () {
  const STORAGE_KEY = 'wishlist:v1';
  const doc = document;
  const heartSelector = '[data-wishlist-button]';
  const countSelector = '[data-wishlist-count]';

  const store = {
    _read() { try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch { return []; } },
    _write(list) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
        dispatchEvent(new CustomEvent('wishlist:change', { detail: list }));
      } catch {}
    },
    all() { return this._read(); },
    has(id) { return this._read().includes(String(id)); },
    toggle(id) {
      id = String(id);
      const list = this._read();
      const i = list.indexOf(id);
      if (i === -1) list.push(id); else list.splice(i,1);
      this._write(list);
    },
    clear() { this._write([]); }
  };
  window.Wishlist = store;

  function updateHeart(el, active) {
    el.setAttribute('aria-pressed', active ? 'true' : 'false');
    el.classList.toggle('is-active', active);
    const labelOn = el.getAttribute('data-label-on') || 'Fjern fra ønskeliste';
    const labelOff = el.getAttribute('data-label-off') || 'Tilføj til ønskeliste';
    const textEl = el.querySelector('[data-wishlist-label]');
    if (textEl) textEl.textContent = active ? labelOn : labelOff;
    const onIcon = el.querySelector('[data-icon-on]');
    const offIcon = el.querySelector('[data-icon-off]');
    if (onIcon && offIcon) { onIcon.style.display = active ? '' : 'none'; offIcon.style.display = active ? 'none' : ''; }
  }

  function syncHearts() {
    const list = store.all();
    doc.querySelectorAll(heartSelector).forEach(btn => {
      const id = btn.getAttribute('data-product-id');
      updateHeart(btn, id && list.includes(String(id)));
    });
    doc.querySelectorAll(countSelector).forEach(el => el.textContent = String(list.length));
  }

  doc.addEventListener('click', (e) => {
    const btn = e.target.closest(heartSelector);
    if (!btn) return;
    e.preventDefault();
    const id = btn.getAttribute('data-product-id');
    if (!id) return;
    store.toggle(id);
    updateHeart(btn, store.has(id));
  });

  addEventListener('wishlist:change', syncHearts);
  doc.addEventListener('DOMContentLoaded', syncHearts);
  addEventListener('shopify:section:load', syncHearts);
})();
